<template>
  <div class="page notranslate logged-out">
    <banner nav-public />
    <main class="content">
      <h2 v-t>You've been logged out.</h2>
      <div class="layout">
        <div class="form-container">
          <div>
            <hybrid-signin-form :title="title" />
            <p v-if="brand !== 'assante'" class="legacy-msg">
              <span v-t>Please login from our</span>
              <a v-t :href="loginUrl">new site</a>.
              <br />
              <span v-t>This page will soon be unavailable.</span>
            </p>
          </div>
        </div>
        <div class="mobile-app">
          <div class="mobile-text">
            <h4 v-t class="miss-us">Miss us already?</h4>
            <p v-t class="get-mobile-app">Get the mobile app.</p>
            <div class="stores">
              <a class="icon xlarge" :href="iosUrl" target="_blank" noreferrer noopener>
                <svg height="32" viewBox="0 0 72 72" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <title v-t>iOS AppStore</title>
                  <path d="M36,0 C16.1176471,0 0,16.1176471 0,36 C0,55.8823529 16.1176471,72 36,72 C55.8823529,72 72,55.8823529 72,36 C72,16.1176471 55.8823529,0 36,0 Z" fill="#303030" />
                  <path d="M37.2823529,19.9058824 C38.6,18.3058824 40.8588235,17.0823529 42.7882353,16.9411765 C43.1176471,19.1294118 42.2117647,21.2705882 41.0352941,22.7882353 C39.7764706,24.4117647 37.5882353,25.6705882 35.4823529,25.6 C35.0941176,23.5058824 36.0823529,21.3529412 37.2823529,19.9058824 Z M49.1294118,47.7176471 C47.6117647,50.0352941 45.4705882,52.9058824 42.8117647,52.9294118 C40.4588235,52.9529412 39.8470588,51.4 36.6470588,51.4117647 C33.4470588,51.4235294 32.7764706,52.9529412 30.4235294,52.9294118 C27.7764706,52.9058824 25.7411765,50.3058824 24.2235294,47.9882353 C19.9764706,41.5294118 19.5294118,33.9294118 22.1529412,29.9058824 C24.0117647,27.0352941 26.9529412,25.3647059 29.7176471,25.3647059 C32.5294118,25.3647059 34.2941176,26.9058824 36.6235294,26.9058824 C38.8823529,26.9058824 40.2588235,25.3647059 43.5058824,25.3647059 C45.9647059,25.3647059 48.5647059,26.7058824 50.4235294,29.0117647 C44.3411765,32.3411765 45.3294118,41.0235294 51.4705882,43.3411765 C50.6235294,45.2235294 50.2117647,46.0588235 49.1294118,47.7176471 Z" fill="#FFFFFF" />
                </svg>
              </a>
              <a class="icon xlarge" :href="androidUrl" target="_blank" noreferrer noopener>
                <svg height="32" viewBox="0 0 72 72" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <title v-t>Google Play Store</title>
                  <path d="M36,0 C16.1176471,0 0,16.1176471 0,36 C0,55.8823529 16.1176471,72 36,72 C55.8823529,72 72,55.8823529 72,36 C72,16.1176471 55.8823529,0 36,0 Z" fill="#303030" />
                  <path d="M23.8,40.8 C23.8,42.0588235 22.7764706,43.0823529 21.5176471,43.0823529 C20.2588235,43.0823529 19.2235294,42.0588235 19.2235294,40.8 L19.2235294,31.0235294 C19.2235294,29.7647059 20.2470588,28.7411765 21.5176471,28.7411765 C22.7764706,28.7411765 23.8,29.7647059 23.8,31.0235294 L23.8,40.8 Z M46.6705882,30.6352941 L46.6705882,32.1882353 L46.6705882,45.5058824 C46.6705882,46.8352941 45.5882353,47.9176471 44.2588235,47.9176471 L42.5176471,47.9176471 C42.5764706,48.1176471 42.6117647,48.3294118 42.6117647,48.5529412 L42.6117647,48.6823529 L42.6117647,49.4470588 L42.6117647,53.3882353 C42.6117647,54.6470588 41.5882353,55.6705882 40.3294118,55.6705882 C39.0705882,55.6705882 38.0470588,54.6470588 38.0470588,53.3882353 L38.0470588,49.4470588 L38.0470588,48.6823529 L38.0470588,48.5529412 C38.0470588,48.3294118 38.0823529,48.1176471 38.1411765,47.9176471 L33.8823529,47.9176471 C33.9411765,48.1176471 33.9764706,48.3294118 33.9764706,48.5529412 L33.9764706,48.6823529 L33.9764706,49.4470588 L33.9764706,53.3882353 C33.9764706,54.6470588 32.9529412,55.6705882 31.6823529,55.6705882 C30.4117647,55.6705882 29.4,54.6470588 29.4,53.3882353 L29.4,49.4470588 L29.4,48.6823529 L29.4,48.5529412 C29.4,48.3294118 29.4352941,48.1176471 29.4941176,47.9176471 L27.7529412,47.9176471 C26.4235294,47.9176471 25.3411765,46.8352941 25.3411765,45.5058824 L25.3411765,32.1882353 L25.3411765,30.6352941 L25.3411765,28.7294118 L25.5058824,28.7294118 L46.5176471,28.7294118 L46.6823529,28.7294118 L46.6823529,30.6352941 L46.6705882,30.6352941 Z M25.3294118,27.2117647 C25.3294118,23.9411765 27.5176471,21.0941176 30.7529412,19.5882353 L30.3176471,18.9411765 L29.8941176,18.3058824 L28.9411765,16.8823529 C28.8235294,16.7058824 28.8705882,16.4705882 29.0470588,16.3529412 C29.2235294,16.2352941 29.4588235,16.2823529 29.5764706,16.4588235 L30.6,17.9882353 L31.0235294,18.6352941 L31.4588235,19.2823529 C32.8352941,18.7529412 34.3764706,18.4470588 35.9882353,18.4470588 C37.6117647,18.4470588 39.1411765,18.7411765 40.5176471,19.2823529 L40.9529412,18.6352941 L41.3882353,17.9882353 L42.4117647,16.4588235 C42.5294118,16.2823529 42.7647059,16.2352941 42.9411765,16.3529412 C43.1176471,16.4705882 43.1647059,16.7058824 43.0470588,16.8823529 L42.0941176,18.3058824 L41.6705882,18.9411765 L41.2470588,19.5882353 C44.4823529,21.0941176 46.6705882,23.9529412 46.6705882,27.2117647 L25.3294118,27.2117647 Z M52.7647059,40.8 C52.7647059,42.0588235 51.7411765,43.0823529 50.4823529,43.0823529 C49.2235294,43.0823529 48.1882353,42.0588235 48.1882353,40.8 L48.1882353,31.0235294 C48.1882353,29.7647059 49.2117647,28.7411765 50.4823529,28.7411765 C51.7411765,28.7411765 52.7647059,29.7647059 52.7647059,31.0235294 L52.7647059,40.8 Z" fill="#FFFFFF" fill-rule="nonzero" />
                  <path d="M31.4235294,21.8823529 C30.7882353,21.8823529 30.2823529,22.3882353 30.2823529,23.0235294 C30.2823529,23.6588235 30.7882353,24.1647059 31.4235294,24.1647059 C32.0588235,24.1647059 32.5647059,23.6470588 32.5647059,23.0235294 C32.5647059,22.3882353 32.0588235,21.8823529 31.4235294,21.8823529 Z" fill="#303030" fill-rule="nonzero" />
                  <path d="M40.5764706,21.8823529 C39.9411765,21.8823529 39.4352941,22.3882353 39.4352941,23.0235294 C39.4352941,23.6588235 39.9411765,24.1647059 40.5764706,24.1647059 C41.2117647,24.1647059 41.7176471,23.6470588 41.7176471,23.0235294 C41.7176471,22.3882353 41.2,21.8823529 40.5764706,21.8823529 Z" fill="#303030" fill-rule="nonzero" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </main>
    <footer-component @language-changed="languageChanged" />
  </div>
</template>

<script>
import Banner from '@layoutTheme/banner';
import Footer from '@layoutTheme/footer';
import locale from 'utils/locale';
import HybridSigninForm from '~vue/components/forms/form-hybrid-signin';
import { BRAND } from '~vue/config/brand';
import { CommonDashboardSigninUrls } from '~vue/config/common-dashboard-web';

let iosUrl;
let androidUrl;
if (BRAND === 'wealthbar') {
  iosUrl = 'https://itunes.apple.com/us/app/wealthbar/id978421974?mt=8';
  androidUrl = 'https://play.google.com/store/apps/details?id=com.wealthbar.android&amp;hl=en';
} else {
  iosUrl = 'https://itunes.apple.com/app/id1453910096';
  androidUrl = 'https://play.google.com/store/apps/details?id=com.assante.android&hl=en';
}

export default {
  components: {
    Banner,
    'footer-component': Footer,
    HybridSigninForm,
  },
  data() {
    return {
      language: null,
      iosUrl,
      androidUrl,
      title: { en: 'Sign back in', fr: 'Se connecter de nouveau' },
      brand: BRAND,
    };
  },
  computed: {
    loginUrl() {
      return this.$lang.slice(0, 2) === 'fr' ? CommonDashboardSigninUrls.fr : CommonDashboardSigninUrls.en;
    },
  },
  created() {
    this.language = locale.getLanguage();
  },
  methods: {
    languageChanged(newLanguage) {
      this.language = newLanguage;
    },
  },
};
</script>

<style lang="scss" scoped>
  .page {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .content {
    margin-top: 2rem;
    color: $neutral-900;

    h2 {
      text-align: center;
    }

    @media #{$screen-width-large} {
      margin: 1rem 0 1rem;
    }

    .layout {
      display: flex;
      flex-direction: column;
      width: 100%;
      align-items: center;

      @media #{$screen-width-large} {
        flex-direction: row;
        margin: 4rem 0 3.5rem;
      }

      .form-container {
        width: 100%;
        padding-bottom: 2.5rem;
        border-bottom: 2px solid $neutral-100;

        @media #{$screen-width-large} {
          width: 50%;
          display: flex;
          align-items: flex-end;
          flex-direction: column;
          padding-right: 3rem;
          padding-bottom: 1rem;
          border-bottom: none;
          border-right: 2px solid $neutral-100;
        }

        > div {
          width: 90%;
          max-width: 20rem;
          margin: 0 auto;

          @media #{$screen-width-large} {
            margin: 0;
          }
        }
      }
    }
  }

  .legacy-msg {
    margin-top: 1.25rem;
    text-align: center;
    font-size: 1.1rem;
    line-height: 1.5rem;
  }

  .mobile-app {
    width: 100%;
    margin: 2.5rem 0;
    max-width: 22rem;
    min-height: 5.625rem;

    @media #{$screen-width-large} {
      width: 50%;
      margin-top: 0;
      padding-left: 3rem;
      max-width: inherit;
    }

    .mobile-image {
      width: 18rem;
      height: 18rem;
      position: relative;
      left: -2rem;

      @media #{$screen-width-large} {
        position: inherit;
        left: inherit;
      }
    }

    .mobile-text {
      position: absolute;
      left: 30%;
      top: 0rem;
      text-align: center;

      @media #{$screen-width-large} {
        left: 8rem;
      }

      .miss-us {
        margin: 0;
      }

      .get-mobile-app {
        margin: 0.25rem 0 0.5rem;
      }

      .stores {
        text-align: center;
      }
    }
  }
  a.icon.xlarge svg {
    width: 2rem;
    height: 2rem;
  }
</style>
